export default {
    type: 'date',
    config: {
        defaultWidth: {
            default: 80,
            sheet: 160
        },
    },
    default: {
        label: 'Last play'
    },
    unique: [],
    sort: 'played.last',
    lang: {
        name: 'Date Last Played',
        views: ['list', 'sheet', 'grid'],
        category: ['User', 'Plays'],
        description: 'Date of the last play of the game.'
    },
    filters: ['last.played']
}